import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { get } from 'lodash';
import { ACCOUNTS_QUERY } from '@api/graphql/profile/applications';
import { Loading } from '@components/common';
import { AccountTable } from './components';

import ApplicationContext from './context';
import { PageWrapper } from './styled';

const Applications = () => {
  const { loading, data } = useQuery(ACCOUNTS_QUERY, { fetchPolicy: 'network-only' });

  if (loading) {
    return <Loading />;
  }

  const profiles = get(data, 'self.user.profiles');
  return (
    <ApplicationContext.Provider
      value={{
        theme: 'light',
      }}
    >
      <PageWrapper>
        <AccountTable profiles={profiles} />
      </PageWrapper>
    </ApplicationContext.Provider>
  );
};

export default Applications;
